<template>
  <div class="catering">
    <banner clazz="solution-banner" ref="solutionBanner" :url="currentId" isSolution>
    </banner>
    <div class="catering-manage">
      <div class="tc w1200">
        <h1 class="tc title">{{cardsData.title}}</h1>
        <div class="dib border-bottom"></div>
        <p class="desc">{{cardsData.describe}}</p>
        <ul class="clearfix cards">
          <li v-for="item in cardsData.data">
            <h2 class="cards-title">{{item.title}}</h2>
            <p class="cards-desc">{{item.describe}}</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="tc catering-challenge">
      <div class="w1200">
        <h1 class="title">{{listData.title}}</h1>
        <div class="dib border-bottom"></div>
        <p class="desc">{{listData.describe}}</p>
        <ul class="clearfix challenge-list">
          <li v-for="item in listData.data" :style="{'width': 1200 / listData.data.length + 'px'}">
            <div class="challenge-li">
              <img v-lazy="item.img" :alt="item.title">
              <h2 class="challenge-title">{{item.title}}</h2>
              <p class="challenge-desc">{{item.describe}}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="catering-layout">
      <div class="w1200">
        <div class="tc">
          <h1 class="title">{{layoutData.title}}</h1>
          <div class="dib border-bottom"></div>
          <p class="desc">{{layoutData.describe}}</p>
          <div v-show="false" class="button-list tc">
            <el-button class="video-button" round @click="openVideoPlayer">查看视频</el-button>
            <el-button class="whitebook-button" round @click="openPdf">下载白皮书</el-button>
          </div>
          <div class="dib layout-bg">
            <img :src="layoutData.cover" alt="">
          </div>
        </div>
        <ul class="clearfix layout-ul">
          <li v-for="item in layoutData.data">
            <div class="clearfix layout-w">
              <div class="fl layout-w-left">
                <img v-lazy="item.img" :alt="item.title">
              </div>
              <div class="fl layout-w-right">
                <h2 class="layout-title">{{item.title}}</h2>
                <p class="layout-desc">
                  {{item.describe}}
                </p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="catering-product">
      <div class="tc w1200">
        <h1 class="title">{{productData.title}}</h1>
        <div class="dib border-bottom"></div>
        <p class="desc">实现一个平台管理寻源、招投标到财务对账全流程采购管理</p>
        <ul class="clearfix product-list">
          <li :style="{'width': 1200 / productData.data.length + 'px'}" v-for="item in productData.data">
            <img v-lazy="item.img ? $global.globalPath + item.img : ''" alt="实现一个平台管理寻源">
            <h2 class="product-title">{{item.title}}</h2>
            <div class="product-btn">
              <button round @click="goRooter(item.url)">查看更多</button>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="catering-purchase">
      <div class="tc w1200">
        <h1 class="title">他们采购管理已发生翻天覆地的变化</h1>
        <div class="dib border-bottom"></div>
        <div class="purchase-carousel">
          <el-carousel height="266px" indicator-position="none">
            <el-carousel-item v-for="(item, index) in exampleResult" :key="index">
              <div class="carousel-box clearfix">
                <div class="rel carousel-img" v-for="subItem in item">
                  <img :src="$global.globalPath + subItem.jiej_img" alt="他们采购管理已发生翻天覆地的变化">
                  <div class="abs carousel-w"></div>
                  <div class="abs carousel-one"></div>
                  <div class="abs carousel-box-desc">
                    <h2 class="title abs">{{subItem.title}}</h2>
                    <div class="carousel-s">
                      <p class="desc">{{subItem.jiej_describe}}</p>
                      <div class="look-detail">
                        <el-button round @click="goClientDetail(subItem.id, subItem.status)">了解详情</el-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="catering-start-btn">
          <button round @click="goMoreCase">更多案例</button>
        </div>
      </div>
    </div>
    <div class="catering-start">
      <div class="tc w1200">
        <h1 class="title">现在就开始</h1>
        <div class="dib border-bottom"></div>
        <div class="desc">
          <p>每个业务都有自己独特的挑战和机遇。所以甄云随需而变</p>
          <p>创造独特的解决方案，适合您的行业帮助您应用采购技术，实现采购管理变革！</p>
        </div>
        <div class="catering-tips">咨询热线：400-116-0808</div>
        <div class="catering-start-btn">
          <button round @click="goRegister(`jiejuefangan-${currentSolution.code}-yanshi`)">申请演示</button>
        </div>
      </div>
    </div>
    <!--视频弹窗-->
    <div class="catering-video">
      <el-dialog
        custom-class="customClass"
        :visible.sync="centerDialogVisible"
        width="800px"
        @close="closeVideoDialog">
        <div class="video-test">
          <div class="video-img tc cp" v-show="showVideoImg" @click.stop.prevent="videoPlay">
            <h2 class="video-title dib">{{videoText}}</h2>
          </div>
          <div class="homeDialog-video" @click.stop.prevent="videoClick">
            <video :src="videoLink" id="homeVideo"
                   @seeked="videoSeek" @pause="videoClick"
                   @error="videoError" @ended="videoDown"
                   preload="auto" controls="controls" autoplay>
            </video>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import banner from '../common/banner.vue'
import solutionIndex from '../../assets/js/solutionIndex.json'

export default {
  inject: ['reload', 'goRooter', 'openRegister'],
  name: 'solution',
  //  metaInfo () {
  //    return {
  //      title: this.meta.title, // set a title
  //      meta: [{ // set meta
  //        name: 'keywords',
  //        content: this.meta.keywords
  //      },
  //      {
  //        name: 'description',
  //        content: this.meta.describe
  //      }]
  //    }
  //  },
  components: {
    banner
  },
  data () {
    return {
      solutionIndex: solutionIndex.data,
      currentSolution: {
        id: '1',
        name: '医药行业',
        script: 'medical'
      },
      cardsData: this.$store.state.solutionCardsData || {},
      listData: this.$store.state.solutionListData || {},
      layoutData: this.$store.state.solutionLayoutData || {},
      productData: {
        title: '餐饮行业产品',
        data: []
      },
      exampleData: [
        {
          title: '周黑鸭1',
          desc: '实现集中化采购，有效整合门店，总部，分公司需求，提升采购效率，降低采购成本',
          img: require('../../assets/img/catering/img1.png')
        },
        {
          title: '周黑鸭2',
          desc: '实现集中化采购，有效整合门店，总部，分公司需求，提升采购效率，降低采购成本',
          img: require('../../assets/img/catering/img1.png')
        },
        {
          title: '周黑鸭3',
          desc: '实现集中化采购，有效整合门店，总部，分公司需求，提升采购效率，降低采购成本',
          img: require('../../assets/img/catering/img1.png')
        },
        {
          title: '周黑鸭4',
          desc: '实现集中化采购，有效整合门店，总部，分公司需求，提升采购效率，降低采购成本',
          img: require('../../assets/img/catering/img1.png')
        },
        {
          title: '周黑鸭5',
          desc: '实现集中化采购，有效整合门店，总部，分公司需求，提升采购效率，降低采购成本',
          img: require('../../assets/img/catering/img1.png')
        },
        {
          title: '周黑鸭6',
          desc: '实现集中化采购，有效整合门店，总部，分公司需求，提升采购效率，降低采购成本',
          img: require('../../assets/img/catering/img1.png')
        },
        {
          title: '周黑鸭7',
          desc: '实现集中化采购，有效整合门店，总部，分公司需求，提升采购效率，降低采购成本',
          img: require('../../assets/img/catering/img1.png')
        }
      ],
      exampleResult: [],
      currentId: 1,
      currentCode: 'yiyao',
      centerDialogVisible: false,
      videoText: '点击开始播放',
      showVideoImg: true,
      videoLink: '',
      pdfLink: '',
      meta: {
        title: '',
        keywords: '',
        describe: ''
      }
    }
  },
  methods: {
    goRegister (code) {
      this.openRegister(false, code, this.currentSolution.code)
    },
    getSolutionProduct () {
      this.$api.post('/solution/solution_product', { cat_id: this.currentId }, (r) => {
        if (r.code === 0) {
          this.productData.data = r.data
        } else {
          this.$message.error(r.msg)
        }
      })
    },
    getSolutionExample () {
      this.$api.post('/solution/solution_case', { cat_id: this.currentId }, (r) => {
        if (r.code === 0) {
          this.exampleResult = []
          for (let i = 0; i < r.data.length; i += 2) {
            this.exampleResult.push(r.data.slice(i, i + 2))
          }
        } else {
          this.$message.error(r.msg)
        }
      })
    },
    getStaticData () {
        import('../../assets/js/solution/' + this.currentSolution.script + '.js').then((module) => {
          this.cardsData = module.cardsData
          this.listData = module.listData
          this.layoutData = module.layoutData
        }).catch((err) => {
          this.$message.error(err || '数据加载失败')
          this.$router.push({
            path: 'Industry'
          })
        })
    },
    // 更多案例
    goMoreCase () {
      let routeObj = this.$router.resolve({ path: '/clientele' })
      window.open(routeObj.href, '_blank')
    },
    goClientDetail (id, status) {
      // let routeUrl = this.$router.resolve({
      //   name: 'ClienteleDetile',
      //   query: {
      //     id: id
      //   }
      // })
      // if (status === '0') {
      //   window.open(routeUrl.href, '_self')
      // } else if (status === '1') {
      //   window.open(routeUrl.href, '_blank')
      // }
      if (status === '0') {
        this.$router.push({
          name: 'ClienteleDetile',
          query: {
            id: id
          }
        })
      } else if (status === '1') {
        this.$api.post('/cases/twenty_four_hour', '', (r) => {
          if (r.code === 0) {
            if (r.data === 1) {
              this.$router.push({
                name: 'ClienteleDetile',
                query: {
                  id: id
                }
              })
            } else {
              this.openRegister(false, 'solution', this.currentSolution.code)
            }
          } else {
            this.$message.error(r.message)
          }
        })
      } else {

      }
    },
    getSolutionTDK () {
      this.$api.post('/solution/solution_tdk', { cat_id: this.currentId }, (r) => {
        if (r.code === 0) {
          this.meta.title = r.data.title
          this.meta.describe = r.data.describe
          this.meta.keywords = r.data.keywords
        } else {
          this.$message.error(r.msg)
        }
      })
    },
    videoSeek () {
      let videoDom = document.getElementById('homeVideo')
      if (videoDom.played) {
        this.showVideoImg = false
      }
    },
    videoClick () {
      let videoDom = document.getElementById('homeVideo')
      if (videoDom.error) {
        return false
      }
      if (videoDom.played) {
        this.videoText = '点击继续播放'
        videoDom.pause()
        this.showVideoImg = true
      } else {
        videoDom.play()
        this.showVideoImg = false
      }
    },
    videoPlay () {
      let videoDom = document.getElementById('homeVideo')
      if (videoDom.error) {
        return false
      }
      if (videoDom.paused) {
        videoDom.play()
        this.showVideoImg = false
      } else {
        videoDom.pause()
        this.showVideoImg = true
      }
    },
    videoDown () {
      this.videoText = '点击开始播放'
      this.showVideoImg = true
    },
    videoError () {
      this.videoText = '视频文件加载错误'
    },
    openVideoPlayer () {
      this.centerDialogVisible = false
      this.showVideoImg = true
      this.$nextTick(() => {
        let videoDom = document.getElementById('homeVideo')
        videoDom.play()
      })
    },
    closeVideoDialog () {
      let videoDom = document.getElementById('homeVideo')
      this.videoText = '点击开始播放'
      this.showVideoImg = false
      videoDom.load()
    },
    getVideoDate () {
      this.$api.post('/solution/solution_module', { cat_id: this.currentId }, (r) => {
        if (r.code === 0) {
          this.videoLink = r.data.url
          this.pdfLink = r.data.path
        } else {
          this.$message.error(r.message)
        }
      })
    },
    openPdf () {
      window.open(this.pdfLink, '_blank')
    }
  },
  created () {
    this.currentCode = this.$route.params.code || 'yiyao'
    this.currentSolution = this.solutionIndex.find((item) => {
      return item.code === this.currentCode
    })
    if (this.currentSolution === undefined) {
      this.$router.push({
        path: '/404'
      })
    } else {
      this.currentId = this.currentSolution.id || 1
      this.productData.title = this.currentSolution.name + '产品'
      //      this.getStaticData()
      this.getSolutionProduct()
      this.getSolutionExample()
      //      this.getSolutionTDK()
      this.getVideoDate()
    }
  },
  beforeRouteUpdate (to, from, next) {
    this.currentCode = to.params.code || 'yiyao'
    this.currentSolution = this.solutionIndex.find((item) => {
      return item.code === this.currentCode
    })
    if (this.currentSolution === undefined) {
      this.$router.push({
        path: '/404'
      })
    } else {
      this.currentId = this.currentSolution.id || 1
      this.productData.title = this.currentSolution.name + '产品'
      //      this.getStaticData()
      this.getSolutionProduct()
      this.getSolutionExample()
      //    this.getSolutionTDK()
      this.getVideoDate()
      this.$refs.solutionBanner.getBanner(this.currentId)
      next()
    }
  }
}
</script>

<style lang="scss">
  @import "../../../static/css/solution.scss";
</style>



// WEBPACK FOOTER //
// solution.vue?ea7d9f58